import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFullPodcast } from "@store/action/planning/PodcastAction";
import { Link } from "react-router-dom";
import { addMusic } from "@src/redux/action/player/PlayerFrontOfficeAction";
import { activeThreeDots } from "@src/@core/components/tuneIn/main.js";
import { BsMusicNoteList } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import BreadCrumbs from "@components/breadcrumbs/index1";
import Filter from "./Filter";
import ReactPaginate from "react-paginate";

const URL = process.env.REACT_APP_MICRO_PLANING_URL;

const Podcast = () => {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);
  activeThreeDots();
  const dispatch = useDispatch();
  const store = useSelector((state) => state.podcastReducer);
  const datas = store.data;
  const count = store.total / 5;

  useEffect(() => {
    dispatch(
      getFullPodcast({
        page: currentPage,
        per_page: 5,
        search: window.location.search,
      })
    );
    return () => {
      dispatch({
        type: "EMPTY_GET_FULL_PODCASTS",
      });
    };
  }, [dispatch, window.location.search]);
  const handlePageChange = (x) => {
    setCurrentPage(x.selected + 1);
    dispatch(
      getFullPodcast({
        page: x.selected + 1,
        per_page: 5,
        search: window.location.search,
      })
    );
  };
  const PlayerFrontOfficeReducer = useSelector(
    (state) => state.PlayerFrontOfficeReducer
  );

  return (
    <div>
      <BreadCrumbs breadCrumbTitle={t("Podcast")} />
      <div className="blog_category_wrapper blog_single_wrapper ms_cover">
        <div className="container" style={{ maxWidth: "90%" }}>
          <div className="row">
            <Filter
              t={t}
              store={store}
              dispatch={dispatch}
              setCurrentPage={setCurrentPage}
            />
            {datas.length ? (
              <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 shop_sidebar">
                <div className="row">
                  <div className="col-md-12">
                    <div className="container" style={{ maxWidth: "90%" }}>
                      <div className="row">
                        <div className="col-12">
                          {datas?.map((item, i) => {
                            return (
                              <div
                                className="top_songs_list free_music_wrapper ms_cover"
                                key={i}
                              >
                                <div className="top_songs_list_left">
                                  <div className="treanding_slider_main_box top_lis_left_content">
                                    <div className="top_songs_list0img">
                                      <img
                                        height="50px"
                                        src={item.empic}
                                        alt="img"
                                      />
                                      <div className="ms_treanding_box_overlay">
                                        <div className="ms_tranding_box_overlay" />
                                        <div className="tranding_play_icon">
                                          {PlayerFrontOfficeReducer?.currentSong ===
                                          item.file ? (
                                            <BsMusicNoteList size={20} />
                                          ) : (
                                            <a
                                              onClick={() =>
                                                dispatch(
                                                  addMusic({
                                                    currentsong: item.file,
                                                    download: `${URL}/podcast/download/${item.id}`,
                                                    namesong: `${item.podcastname}`,
                                                    songimg: item.empic,
                                                    item_data: item,
                                                    has_video:
                                                      item.podcastname.endsWith(
                                                        "mp4"
                                                      ) && true,
                                                    is_web_rtc: false,
                                                    name_id: item.podcastname,
                                                  })
                                                )
                                              }
                                            >
                                              <i className="flaticon-play-button" />
                                            </a>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="release_content_artist top_list_content_artist"
                                      style={{
                                        minWidth: "250px",
                                        maxWidth: "450px",
                                      }}
                                    >
                                      <p className="text-truncate">
                                        <Link to={`/podcast/${item.id}`}>
                                          {t("Emission name")}: {item.emname}
                                        </Link>
                                      </p>
                                      <p className="various_artist_text text-truncate">
                                        <Link to={`/podcast/${item.id}`}>
                                          {t("Episode name")}: {item.epname}
                                        </Link>
                                      </p>
                                      <p className="various_artist_text">
                                        {t("Date")}: {item.record_datetime}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div className="top_songs_list_right">
                                  <div className="top_list_tract_view">
                                    <a
                                      href={`${URL}/podcast/download/${item.id}`}
                                      style={{ color: "#fa5b41" }}
                                      download
                                    >
                                      <i className="flaticon-download" />
                                    </a>
                                  </div>
                                  {/* <div className="top_song_list_picks">
                                  <div className="ms_tranding_more_icon">
                                    <i className="flaticon-menu" />
                                  </div>
                                  <ul className="tranding_more_option">
                                    <li>
                                      <a href="#">
                                        <span className="opt_icon">
                                          <i className="flaticon-playlist" />
                                        </span>
                                        Add To playlist
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#">
                                        <span className="opt_icon">
                                          <i className="flaticon-star" />
                                        </span>
                                        favourite
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#">
                                        <span className="opt_icon">
                                          <i className="flaticon-share" />
                                        </span>
                                        share
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#">
                                        <span className="opt_icon">
                                          <i className="flaticon-download" />
                                        </span>
                                        download now
                                      </a>
                                    </li>
                                    <li>
                                      <a href="#">
                                        <span className="opt_icon">
                                          <i className="flaticon-trash" />
                                        </span>
                                        delete
                                      </a>
                                    </li>
                                  </ul>
                                </div> */}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="blog_pagination_section ms_cover">
                    <ReactPaginate
                      previousLabel={
                        <p className="prev">
                          <i className="flaticon-left-arrow" />
                        </p>
                      }
                      nextLabel={
                        <p className="next">
                          <i className="flaticon-right-arrow" />
                        </p>
                      }
                      pageRangeDisplayed={2}
                      marginPagesDisplayed={2}
                      pageCount={count || 1}
                      breakLabel="..."
                      activeClassName="third_pagger"
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      onPageChange={(page) => handlePageChange(page)}
                      pageClassName={"page-item"}
                      containerClassName={
                        "pagination react-paginate justify-content-end p-1"
                      }
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div className="d-flex justify-content-center mt-2">
                <p>{t("No Results")}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Podcast;
